//* ============================================================
//* Webshop Product Filter Binding Override
//* ============================================================

(() => {
    frappe.ready(() => {
        const Orig = webshop.ProductView;
        if (!Orig) return;
        class ProductViewPatched extends Orig {
            /**
             * Overrides the default ProductView filter binding logic.
             *
             * Additional handling:
             * - variant attribute filters (checkbox & radio)
             *
             * This override extends the default webshop filtering
             * to support custom attribute-based filtering.
             *
             * Updates internal filter state and triggers route changes
             * whenever a filter is modified.
             */

            bind_filters(){
                let me = this;
                this.field_filters = {};
                this.attribute_filters = {};

                $('.product-filter').off('change.custom').on('change.custom', (e) => {
                    me.from_filters = true;

                    const $checkbox = $(e.target);
                    const is_checked = $checkbox.is(':checked');

                    if ($checkbox.is('.attribute-filter')) {
                        const {
                            attributeName: attribute_name,
                            attributeValue: attribute_value
                        } = $checkbox.data();

                        if ($checkbox.attr("type") === "radio") {
                            this.attribute_filters[attribute_name] = [attribute_value];
                            me.change_route_with_filters();
                            return;
                        }

                        if (is_checked) {
                            this.attribute_filters[attribute_name] =
                                this.attribute_filters[attribute_name] || [];
                            this.attribute_filters[attribute_name].push(attribute_value);
                        } else {
                            this.attribute_filters[attribute_name] =
                                (this.attribute_filters[attribute_name] || [])
                                    .filter(v => v !== attribute_value);
                        }

                        if (!this.attribute_filters[attribute_name]?.length) {
                            delete this.attribute_filters[attribute_name];
                        }
                    } else if (
                        $checkbox.is('.field-filter') ||
                        $checkbox.is('.discount-filter')
                    ) {
                        const {
                            filterName: filter_name,
                            filterValue: filter_value
                        } = $checkbox.data();

                        if ($checkbox.is('.discount-filter')) {
                            delete this.field_filters["discount"];
                        }

                        if (is_checked) {
                            this.field_filters[filter_name] =
                                this.field_filters[filter_name] || [];
                            if (!in_list(this.field_filters[filter_name], filter_value)) {
                                this.field_filters[filter_name].push(filter_value);
                            }
                        } else {
                            this.field_filters[filter_name] =
                                (this.field_filters[filter_name] || [])
                                    .filter(v => v !== filter_value);
                        }

                        if (!this.field_filters[filter_name]?.length) {
                            delete this.field_filters[filter_name];
                        }
                    }

                    me.change_route_with_filters();
                });

                $('.filter-lookup-input').on(
                    'keydown',
                    frappe.utils.debounce((e) => {
                        const $input = $(e.target);
                        const keyword = ($input.val() || '').toLowerCase();
                        const $filter_options = $input.next('.filter-options');

                        $filter_options.find('.filter-lookup-wrapper').show();
                        $filter_options.find('.filter-lookup-wrapper').each((i, el) => {
                            const $el = $(el);
                            const value = ($el.data('value') || '').toLowerCase();
                            if (!value.includes(keyword)) {
                                $el.hide();
                            }
                        });
                    }, 300)
                );
            }

            get_item_filter_data(from_filters=false, opts={}) {
                // Get and render all Product related views
                // opts.append: true when this call extends the current list
                // (load-more / show-all, PIT-TASK-2027-000135)
                let me = this;
                this.from_filters = from_filters;
                this._append_batch = !!opts.append;
                let args = this.get_query_filters();
                if (opts.start !== undefined) {
                    args.start = opts.start;
                }

                this.disable_view_toggler(true);
                if (!this._append_batch) {
                    this._show_skeleton();
                }

                // Rapid filter clicks fire one request per click. Cancel the
                // previous one, otherwise a slower earlier response can arrive
                // last and render items that no longer match the active filters.
                if (this.filter_request && this.filter_request.abort) {
                    this.filter_request.abort();
                }

                this.filter_request = frappe.call({
                    method: "webshop.webshop.api.get_product_filter_data",
                    args: {
                        query_args: args
                    },
                    callback: function(result) {
                        me.filter_request = null;
                        if (!me._append_batch) {
                            me._hide_skeleton();
                        }
                        if (!result || result.exc || !result.message || result.message.exc) {
                            me.render_no_products_section(true);
                        } else {
                            // Sub Category results are independent of Items
                            if (me.item_group && result.message["sub_categories"].length) {
                                me.render_item_sub_categories(result.message["sub_categories"]);
                            }

                            if (!result.message["items"].length) {
                                // if result has no items or result is empty
                                me.render_no_products_section();
                            } else {
                                // Add discount filters
                                me.re_render_discount_filters(result.message["filters"].discount_filters);

                                // bulk_prices_html is already embedded in each item by the server
                                // — no second round-trip needed

                                // Render views
                                me.render_list_view(result.message["items"], result.message["settings"]);
                                me.render_grid_view(result.message["items"], result.message["settings"]);
                                me.render_single_view(result.message["items"], result.message["settings"]);

                                // Portrait image zoom (PIT-TASK-2027-000278):
                                // applied after every render (initial load,
                                // filter change, load-more, show-all) — the
                                // body class carries the configured value.
                                webshop.apply_portrait_image_zoom(me.products_section);

                                // Variant colour dots (webshop standard): the
                                // templates show their available colours on the card.
                                if (webshop.variant_colours) {
                                    webshop.variant_colours.render_result(result.message["items"]);
                                }

                                me.products = result.message["items"];
                                me.product_count = result.message["items_count"];
                                // Keep settings on the view so the view toggler
                                // can pass them to ProductSingle (page length,
                                // PIT-TASK-2027-000138)
                                me.settings = result.message["settings"];

                            // Single view gate (PIT-TASK-2027-000166): when
                            // Webshop Settings.enable_single_view is off, hide
                            // the toggler button and force grid view.
                            me._apply_single_view_gate();

                            // List view gate (PIT-TASK-2027-000311): when
                            // Webshop Settings.enable_list_view is off, hide
                            // the List View button and force grid view.
                            me._apply_list_view_gate();

                                // Track how many items are in the DOM for load-more
                                if (me._append_batch) {
                                    me._loaded = (me._loaded || 0) + result.message["items"].length;
                                } else {
                                    me._loaded = (cint(args.start) || 0) + result.message["items"].length;
                                }
                            }

                            // Bind filter actions
                            if (!from_filters && !me._append_batch) {
                                // If `get_product_filter_data` was triggered after checking a filter,
                                // don't touch filters unnecessarily, only data must change
                                // filter persistence is handle on filter change event
                                me.bind_filters();
                                me.restore_filters_state();
                            }

                            // Bottom paging
                            me.add_paging_section(result.message["settings"]);
                        }

                        me.disable_view_toggler(false);
                    }
                });
            }

            // ── Load-more / show-all (PIT-TASK-2027-000135) ──────────────

            render_grid_view(items, settings) {
                if (this._append_batch && $("#products-grid-area").length) {
                    // Extend the existing grid instead of rebuilding the wrapper
                    new webshop.ProductGrid({
                        items: items,
                        products_section: $("#products-grid-area"),
                        settings: settings,
                        preference: this.preference,
                        append_mode: true
                    });
                    return;
                }
                super.render_grid_view(items, settings);
            }

            render_list_view(items, settings) {
                if (this._append_batch && $("#products-list-area").length) {
                    new webshop.ProductList({
                        items: items,
                        products_section: $("#products-list-area"),
                        settings: settings,
                        preference: this.preference,
                        append_mode: true
                    });
                    return;
                }
                super.render_list_view(items, settings);
            }

            load_more(show_all=false) {
                if (show_all) {
                    this._load_all_remaining();
                } else {
                    this.get_item_filter_data(false, {
                        append: true,
                        start: this._loaded || 0
                    });
                }
            }

            _load_all_remaining() {
                // Fetch the remaining items in background batches and append
                // them progressively. Batch size keeps single requests light
                // and each batch lands in the listing Redis cache.
                const me = this;
                const BATCH = 100;
                const total = this.product_count || 0;

                if ((this._loaded || 0) >= total) {
                    $(".product-paging-area").remove();
                    return;
                }

                let args = this.get_query_filters();
                args.start = this._loaded || 0;
                args.page_length = BATCH;
                args.from_filters = false;

                const $btn = $(".btn-load-all");

                this.filter_request = frappe.call({
                    method: "webshop.webshop.api.get_product_filter_data",
                    args: { query_args: args },
                    callback(result) {
                        me.filter_request = null;
                        if (!result || result.exc || !result.message || result.message.exc) return;

                        const items = result.message["items"];
                        if (!items.length) {
                            $(".product-paging-area").remove();
                            return;
                        }

                        me._append_batch = true;
                        me.render_list_view(items, result.message["settings"]);
                        me.render_grid_view(items, result.message["settings"]);
                        if (webshop.variant_colours) {
                            webshop.variant_colours.render_result(items);
                        }
                        me._loaded = (me._loaded || 0) + items.length;

                        if (me._loaded < (me.product_count || 0)) {
                            $btn.text(`${ __("Show All") } … ${ me._loaded } / ${ me.product_count }`);
                            me._load_all_remaining();
                        } else {
                            $(".product-paging-area").remove();
                        }
                    }
                });
            }

            // ── Single view ──────────────────────────────────────────────

            render_single_view(items, settings) {
                // Don't use the base prepare_product_area_wrapper — it adds Bootstrap
                // "row" class which breaks height inheritance for the single view.
                if (!$("#products-single-area").length) {
                    this.products_section.append(
                        `<div id="products-single-area" class="mt-minus-1"></div>`
                    );
                }
                // Single view disabled in Webshop Settings → never start
                // ProductSingle (PIT-TASK-2027-000166)
                if (!webshop.single_view_enabled(settings)) {
                    $("#products-single-area").addClass("hidden");
                    return;
                }
                new webshop.ProductSingle({
                    query_args: this.get_query_filters(),
                    products_section: $("#products-single-area"),
                    settings: settings,
                    preference: this.preference
                });
            }

            // Hides the #single-view toggler button and falls back to the grid
            // view when Webshop Settings.enable_single_view is off — e.g. a
            // stale localStorage product_view = "Single View". Idempotent; runs
            // after every fetch once settings are known (PIT-TASK-2027-000166).
            _apply_single_view_gate() {
                if (webshop.single_view_enabled(this.settings)) return;

                $("#single-view").hide();

                if (this.preference === "Single View") {
                    localStorage.setItem("product_view", "Grid View");
                    this.preference = "Grid View";
                    $("#products-single-area").addClass("hidden");
                    $("#products-grid-area").removeClass("hidden");
                    $("#products-list-area").addClass("hidden");
                    $(".product-paging-area").show();
                    this.set_view_state();
                }
            }

            // Hides the #list toggler button and falls back to the grid
            // view when Webshop Settings.enable_list_view is off — e.g. a
            // stale localStorage product_view = "List View". Idempotent;
            // runs after every fetch once settings are known
            // (PIT-TASK-2027-000311).
            _apply_list_view_gate() {
                if (webshop.list_view_enabled(this.settings)) return;

                $("#list").hide();

                if (this.preference === "List View") {
                    localStorage.setItem("product_view", "Grid View");
                    this.preference = "Grid View";
                    $("#products-list-area").addClass("hidden");
                    $("#products-grid-area").removeClass("hidden");
                    $("#products-single-area").addClass("hidden");
                    $(".product-paging-area").show();
                    this.set_view_state();
                }
            }

            // ── View toggler overrides ───────────────────────────────────

            render_view_toggler() {
                $(".toolbar").append(`<div class="toggle-container col-4 p-0"></div>`);

                // PIT-TASK-2027-000352: the toggler is built before the listing
                // API responds, so the settings from that response are not
                // available yet. Respect the server-rendered settings instead —
                // a disabled view button must never be part of the initial
                // markup (otherwise it is painted and hidden again once the
                // response arrives = visible flash on every page load).
                const initial_settings = webshop.get_listing_settings(this.products_section);

                // Single view button (leftmost) — only when enabled
                if (webshop.single_view_enabled(initial_settings)) {
                    $(".toggle-container").append(`
                        <div class="form-group mb-0" id="toggle-view">
                            <button id="single-view" class="btn btn-single-view mr-2"
                                title="${ __("Single View") }">
                                <span>
                                    <svg class="icon icon-md" viewBox="0 0 16 16" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect x="2" y="2" width="12" height="12" rx="1.5"
                                            stroke="currentColor" stroke-width="1.5"/>
                                    </svg>
                                </span>
                            </button>
                        </div>
                    `);
                }

                // Grid + List buttons (existing icons). Grid is the fallback
                // view and always rendered; the list button only when enabled.
                ["btn-grid-view", "btn-list-view"].forEach(view => {
                    if (view === "btn-list-view" && !webshop.list_view_enabled(initial_settings)) return;
                    let icon = view === "btn-list-view" ? "list" : "image-view";
                    let id   = view === "btn-list-view" ? "list" : "image-view";
                    $(".toggle-container").append(`
                        <div class="form-group mb-0" id="toggle-view">
                            <button id="${ id }" class="btn ${ view } mr-2">
                                <span>
                                    <svg class="icon icon-md">
                                        <use href="#icon-${ icon }"></use>
                                    </svg>
                                </span>
                            </button>
                        </div>
                    `);
                });
            }

            bind_view_toggler_actions() {
                const me = this;

                $("#single-view").click(function() {
                    // Defensive: single view disabled in Webshop Settings
                    if (!webshop.single_view_enabled(me.settings)) return;
                    $(this).addClass("btn-primary");
                    $(".btn-grid-view, .btn-list-view").removeClass("btn-primary");
                    $("#products-grid-area, #products-list-area").addClass("hidden");
                    $(".product-paging-area").hide();
                    localStorage.setItem("product_view", "Single View");
                    me.preference = "Single View";

                    // Re-instantiate to fetch all items if not already done
                    const $area = $("#products-single-area");
                    if ($area.find(".ws-single-view").length === 0) {
                        $area.removeClass("hidden");
                        new webshop.ProductSingle({
                            query_args: me.get_query_filters(),
                            products_section: $area,
                            settings: me.settings,
                            preference: "Single View"
                        });
                    } else {
                        $area.removeClass("hidden");
                    }
                });

                $("#list").click(function() {
                    // Defensive: list view disabled in Webshop Settings
                    if (!webshop.list_view_enabled(me.settings)) return;
                    $(this).addClass("btn-primary");
                    $("#single-view").removeClass("btn-primary");
                    $(".btn-grid-view").removeClass("btn-primary");
                    $("#products-grid-area, #products-single-area").addClass("hidden");
                    $("#products-list-area").removeClass("hidden");
                    $(".product-paging-area").show();
                    localStorage.setItem("product_view", "List View");
                    me.preference = "List View";
                });

                $("#image-view").click(function() {
                    $(this).addClass("btn-primary");
                    $("#single-view").removeClass("btn-primary");
                    $(".btn-list-view").removeClass("btn-primary");
                    $("#products-list-area, #products-single-area").addClass("hidden");
                    $("#products-grid-area").removeClass("hidden");
                    $(".product-paging-area").show();
                    localStorage.setItem("product_view", "Grid View");
                    me.preference = "Grid View";
                });
            }

            set_view_state() {
                if (this.preference === "List View") {
                    $("#list").addClass("btn-primary");
                    $("#image-view, #single-view").removeClass("btn-primary");
                } else if (this.preference === "Single View") {
                    $("#single-view").addClass("btn-primary");
                    $("#image-view, #list").removeClass("btn-primary");
                } else {
                    $("#image-view").addClass("btn-primary");
                    $("#list, #single-view").removeClass("btn-primary");
                }
            }

            disable_view_toggler(disable = false) {
                $("#list, #image-view, #single-view").prop("disabled", disable);
            }

            _show_skeleton() {
                // Remove any existing skeleton/spinner first
                $('#ws-product-skeleton').remove();

                // PIT-TASK-2027-000235: a simple loading spinner + short text
                // instead of the old card skeleton placeholder blocks.

                const $skeleton = $(`
                    <div id="ws-product-skeleton" class="ws-listing-loading">
                        <div class="ws-loading-spinner"></div>
                        <div class="ws-loading-text">${ __("Produkte werden geladen…") }</div>
                    </div>
                `);

                // Insert into the product listing area
                $('#product-listing').append($skeleton);
            }

            _hide_skeleton() {
                // Remove the loading spinner once the product request completes
                $('#ws-product-skeleton').remove();
            }

            add_paging_section(settings) {
                // Load-more instead of Prev/Next paging (PIT-TASK-2027-000135):
                // "Mehr anzeigen" appends the next page, "Alle anzeigen"
                // streams the rest of the catalogue in batches.
                $(".product-paging-area").remove();

                // Single view navigates via Prev/Next arrows, not batches
                if (this.preference === "Single View") return;
                if (!this.products) return;

                const loaded = this._loaded || 0;
                const total = this.product_count || 0;

                // Nothing more to load → no buttons at all
                if (loaded >= total) return;

                const remaining = total - loaded;
                const more_label = remaining <= (settings.products_per_page || 9)
                    ? `${ __("Show All") } (${ remaining })`
                    : `${ __("Show More") } (${ remaining })`;

                let paging_html = `
                    <div class="row product-paging-area mt-4">
                        <div class="col-12 text-center ws-load-more-area">
                            <button class="btn btn-default btn-load-more">
                                ${ more_label }
                            </button>
                            ${ remaining > (settings.products_per_page || 9)
                                ? `<button class="btn btn-link btn-load-all">
                                        ${ __("Show All") } (${ total })
                                    </button>`
                                : "" }
                        </div>
                    </div>
                `;

                $(".page_content").append(paging_html);

                let me = this;
                $(".btn-load-more").click(() => {
                    $(".btn-load-more, .btn-load-all").prop("disabled", true);
                    me.load_more(false);
                });
                $(".btn-load-all").click(() => {
                    $(".btn-load-more, .btn-load-all").prop("disabled", true);
                    me.load_more(true);
                });
            }

        }
        webshop.ProductView = ProductViewPatched;
    });
})();
